<template>
    <collapse-box-decorator trigger="click">
        <template #default="{ bindings }">
            <button-text v-bind="bindings" :disabled="availableLeads.length === 0">
                <svg-icon :icon="AddIcon" />
                <span><slot /></span>
            </button-text>
        </template>
        <template #content="{ bindings }">
            <collapse-option-container>
                <collapse-box-decorator
                    horizontal-position="right-out"
                    vertical-position="top"
                    fill
                >
                    <template #default="{ bindings: subBindings }">
                        <collapse-option v-bind="subBindings">
                            <flex-container
                                justify-content="space-between"
                                align-items="center"
                                inline
                            >
                                <span>Aan lead</span>
                                <svg-icon :icon="ChevronRightIcon" />
                            </flex-container>
                        </collapse-option>
                    </template>
                    <template #content>
                        <collapse-option-container
                            @mouseenter="bindings.onMouseEnter"
                            @mouseleave="bindings.onMouseLeave"
                        >
                            <collapse-option
                                v-for="lead in availableLeads"
                                :key="lead.id.value"
                                @click="redirectToActionCreate(lead)"
                            >
                                <lead-team-block :lead="lead" />
                            </collapse-option>
                        </collapse-option-container>
                    </template>
                </collapse-box-decorator>
            </collapse-option-container>
        </template>
    </collapse-box-decorator>
</template>

<script lang="ts" setup>
    import AddIcon from '@keyvue/one-material-icons/icons/add.svg?component';
    import ChevronRightIcon from '@keyvue/one-material-icons/icons/chevron_right.svg?component';

    import { ButtonText, CollapseOption, CollapseOptionContainer, FlexContainer, CollapseBoxDecorator, SvgIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import type { Lead } from '@keyvue/one-api-client';
    import LeadTeamBlock from '@components/Blocks/LeadTeamBlock.vue';
    import useParentRoute from '@composables/useParentRoute';
    import { useRouter } from 'vue-router';
    import useContactPageData from '@composables/useContactPageData';
    import useLeadSecurity from '@composables/security/useLeadSecurity';

    export interface Props {
        type?: 'appointment' | 'task',
    }

    const props = withDefaults(defineProps<Props>(), {
        type: 'appointment',
    });

    const createRouteLocation = useParentRoute();
    const router = useRouter();
    const { forLead: leadSecurityForLead } = useLeadSecurity();

    const availableLeads = computed(() => {
        const leads = leadCollection.data.value;

        return leads.filter((lead) => leadSecurityForLead(lead).canViewDetail.value);
    });

    const contactPageData = useContactPageData(String(router.currentRoute.value.params.contactId));

    const redirectToActionCreate = (lead: Lead) => {
        router.push(createRouteLocation({
            name: 'ActionCreate',
            params: {
                leadId: lead.id.value,
            },
            query: {
                type: props.type,
            },
        }, 'lead'));
    };

    const leadCollection = await contactPageData.leadCollection();
</script>
